<template>
  <div class="daifuDetails">
    <div class="neverTop" @click="back">
      <img
        src="https://img.yzcdn.cn/upload_files/2020/08/31/FqcC4dmwQzaB9o500ZpVDJqLKIQj.png"
      />返回
    </div>
    <div class="daifuDetails-header">
      <div class="daifuDetails-header_money">
        <div class="title">代付金额</div>
        <div>
          <!-- <span class="money-icon">￥</span> -->
          <span class="money-num">{{ transPrice(totalPrice) }}</span>
        </div>
        <div v-if="hasOrder" class="time">
          <span style="margin-right:9px">支付剩余时间</span>
          <van-count-down :time="time">
            <template #default="timeData">
              <span class="vanCount-block">{{ fix(timeData.minutes, 2) }}</span>
              <span class="colon">:</span>
              <span class="vanCount-block">{{ fix(timeData.seconds, 2) }}</span>
            </template>
          </van-count-down>
        </div>
        <div v-if="orderStatus == 'create' && firstClick" class="footer-btn">找人代付</div>
        <div v-else class="footer-btn" @click="daiFuPay()">找人代付</div>
        <div class="tip-red">* 只可找安卓手机进行代付，苹果手机不支持代付哦~</div>
      </div>
    </div>
    <div class="daifuDetails-header_center">
      <div class="daifuDetails_dingdan">代付订单信息</div>
      <div class="daifuDetails_flexbox">
        <img
          v-lazy="lazyImage(workbooks.picurl || workbooks.workbookPicurl) || {}"
          class="dingdan-img"
        />
        <div
          style="margin-left:9px;display: flex;flex-direction: column;justify-content: space-between;"
        >
          <div class="daifuDetails_dingdan-title">
            {{ workbooks.name || workbooks.workbookName }}
          </div>
          <div class="daifuDetails_flexbox_money">
            <span style="font-size:13px">￥</span>
            <span>{{ transPrice(workbooks.price) || transPrice(workbooks.workbookPrice) }}</span>
          </div>
        </div>
      </div>
      <div class="daifuDetails_dingdan_border"></div>
      <div class="daifuDetails_dingdan-text">备注</div>
      <van-field
        v-if="!description"
        v-model="remark"
        rows="3"
        autosize
        type="textarea"
        maxlength="40"
        placeholder="我在新华乐子作业答案辅导订阅的课本/练习册，快帮我付款吧，我会感谢你的～"
        show-word-limit
        @input="blurField"
      />
      <div v-if="description" class="description">{{ description }}</div>
    </div>
    <div class="daifuDetails_footer">
      <div class="shuoming">代付说明:</div>
      <p class="daifuDetails_footer_text1">
        1. 代付订单创建成功后30分钟内未付款，订单会自动取消，你可以重新下单。
      </p>
      <p class="daifuDetails_footer_text2">2.如发生退款，实付金额将原路退还代付人。</p>
    </div>
    <van-overlay :show="show" class="daiFu-overlay" @click="show = false">
      <img src="https://img.yzcdn.cn/upload_files/2020/10/19/Fn4a_n7JwrJpFkqNKprc6ycMUF3h.png" />
    </van-overlay>
  </div>
</template>
<script>
import { share } from '@/plugin/wechatJSSdk'
import { Field, CountDown, Toast, Dialog } from 'vant'
import { transPrice, timestamp, fix } from '@/static/js/zjs.js'
export default {
  name: '',
  components: {
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      remark: '', // 备注
      time: '', // 倒计时时间
      show: false,
      workbooks: {}, // 书籍信息
      bookId: '', // 书的id
      totalPrice: '', // 总价
      orderStatus: '', // 订单状态//新创建还是旧的
      ishavedaiFu: false,
      description: '',
      hasOrder: false,
      firstClick: false
    }
  },
  computed: {},
  async mounted() {
    this.bookId = this.$route.query.id
    await this.checkHaveOrder()
  },
  methods: {
    transPrice,
    timestamp,
    fix,
    // 返回
    back() {
      window.history.back()
    },
    blurField(value) {
      if (value.length >= 40) {
        Toast({ duration: 3000, message: '最多40个字哦~' })
      }
    },
    lazyImage(cover) {
      return {
        src: this.$env.ossUrl(cover),
        error: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png',
        loading: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png'
      }
    },
    // 查询是否有未支付订单
    async checkHaveOrder(orderId) {
      const { id } = this.$route.query
      let params
      if (id) {
        params = {
          openid: this.$store.openid,
          ids: [
            {
              id: this.$route.query.id,
              num: 1
            }
          ]
        }
      }
      await this.$http.post('/cms/weixin/user/book/order/checkHaveOrder', params).then((res) => {
        if (res.data && res.data.payOrder) {
          this.details = res.data.payOrder
          this.orderStatus = 'old'
          this.hasOrder = true
          this.workbooks = res.data.payOrder.payOrderGoods[0]
          this.payOrderId = res.data.payOrder.payOrderGoods[0].payOrderId
          this.ishavedaiFu = res.data.payOrder.payAnotherRecordId
          var createTime = new Date(res.data.payOrder.createtime.replace(/-/g, '/')).getTime()
          // ios不支持new Date('2020-01-01')形式  转化为new Date('2020/01/01')
          this.time = new Date(createTime).valueOf() + 30 * 60 * 1000 - timestamp()
        } else {
          this.orderStatus = 'create'
          this.workbooks = res.data.workbooks[0]
        }
        this.totalPrice = res.data.totalPrice
        // 已经创建代付订单
        this.description = res.data.payAnotherRecord && res.data.payAnotherRecord.description
        this.remark = this.description
        this.getShareConfig()
      })
    },
    // 点击找人代付 创建订单 倒计时开始  弹出分享
    async daiFuPay() {

      var payOrderId = this.workbooks.payOrderId || this.$route.query.order_id || ''

      var params = {
        openid: this.$store.openid,
        channel: 'db_df_n_gn',
        body: this.workbooks.name || this.workbooks.workbookName || '',
        description:
          this.remark || '我在新华乐子作业答案辅导订阅的课本/练习册，快帮我付款吧，我会感谢你的～'
      }
      if (this.orderStatus === 'create') {
        params.ids = [
          {
            id: this.$route.query.id || this.workbooks.id,
            num: 1
          }
        ]
      } else {
        params.payOrderId = payOrderId
      }
      this.firstClick = true
      // 代付创建订单
      await this.$http.post('/cms/weixin/user/book/order/create', params).then((res) => {
        if (res.data) {
          this.payOrderId = res.data.payOrderId
          // this.show = true
          window.location.href = `/cms/webapp/home/info/share.html?id=${this.$route.query.id}&payOrderId=${this.payOrderId}`
          this.time = res.data.timeStamp + 30 * 60 * 1000 - timestamp()
          this.hasOrder = true
          this.getShareConfig()
          this.checkHaveOrder(this.payOrderId)
        } else {
          Dialog.alert({
            title: '温馨提示',
            message: '该书籍的订单状态已更新，快去查看吧～',
            theme: 'round-button',
            confirmButtonText: '去查看!'
          }).then(() => {
            window.location.href = '/cms/webapp/home/answer/index.html#/'
          })
        }
      })
    },
    // 分享
    getShareConfig() {
      share({
        title: '我的学习需要您的帮助!',
        desc:
          this.description ||
          '我在新华子衿作业答案辅导订阅的课本/练习册，快帮我付款吧，我会感谢你的～',
        link: `https://${window.location.host}/cms/webapp/home/answer/index.html#/daifuDetails?id=${this.$route.query.id}&payOrderId=${this.payOrderId}`,
        imgUrl: `https://${window.location.host}/cms/static/images/logo-128.png`
      })
      // var apps = ['QQ', 'Weibo', 'QZone', 'Timeline', 'AppMessage']
      // var url = `https://${window.location.host}/cms/webapp/home/answer?hash=daifuDetails&id=${this.$route.query.id}&payOrderId=${this.payOrderId}`
      // var template = {
      //   title: '我的学习需要您的帮助!',
      //   desc:
      //     this.description ||
      //     '我在新华子衿作业答案辅导订阅的课本/练习册，快帮我付款吧，我会感谢你的～',
      //   link: url,
      //   imgUrl: `https://${window.location.host}/cms/static/images/logo-128.png`,
      //   success: () => {
      //     // this.show = false
      //   },
      //   cancel: function() {}
      // }
      // //  防止域名被屏蔽wxshare.zijinshe  liaoning.leziedu
      // template.link =
      //   'http://wxshare.zijinshe.com/cms/webapp/home/redirect.html?url=' + url.replace('?', '&')

      // // 分享
      // this.$wechatJsSdk.then((wx) => {
      //   // wx.updateAppMessageShareData(template)
      //   // wx.updateTimelineShareData(template)
      //   apps.forEach((item) => wx[`onMenuShare${item}`](template))
      // })
    }
  }
}
</script>
<style lang="scss">
.daiFu-overlay {
  img {
    width: 288px;
    margin-left: 63px;
    margin-top: 19px;
  }
}
.van-cell {
  background-color: #fbfafa;
  border-radius: 4px;
  margin-top: 12px;
  font-size: 13px;
  color: #999999;
  padding: 6px 9px 6px;
}
.van-field__control {
  font-size: 13px;
  line-height: 20px;
  color: #333;
}
.van-field__word-limit {
  font-size: 11px;
  color: #999999;
  line-height: 20px;
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #000000;
}
.daifuDetails-header {
  padding: 12px 15px;
  box-sizing: border-box;
  .daifuDetails-header_money {
    width: 343px;
    background: #ffffff;
    padding: 16px 0;
    box-sizing: border-box;
    border-radius: 4px;
    text-align: center;
    .title {
      font-size: 16px;
      color: #999999;
      margin-bottom: 6px;
    }
    .money-icon {
      font-size: 18px;
      margin-right: 4px;
    }
    .money-num {
      font-size: 32px;
      font-weight: normal;
      position: relative;
      &::before {
        content: '￥';
        font-size: 18px;
        position: absolute;
        left: -24px;
        top: 35%;
      }
    }
    .time {
      margin-top: 18px;
      font-size: 14px;
      color: #333333;
      display: flex;
      justify-content: center;
    }
    .footer-btn {
      width: 311px;
      height: 42px;
      font-size: 16px;
      text-align: center;
      line-height: 42px;
      margin-top: 14px;
      display: inline-block;
      color: #ffffff;
      background: linear-gradient(0deg, #ff2638, #ff2638),
        linear-gradient(90deg, #fd735d 0.16%, #fe4e45 100.16%);
      border-radius: 4px;
    }
    .tip-red {
      margin-top: 12px;
      font-size: 12px;
      display: flex;
      align-items: center;
      color: #ff2638;
      padding-left: 16px;
    }
  }
}
.vanCount-block {
  display: inline-block;
  width: 20px;
  height: 18px;
  line-height: 18px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: #3e4159;
  border-radius: 2px;
}
.daifuDetails {
  background: #f6f6f6;
  height: auto;
  min-height: 100vh;
  .neverTop {
    display: flex;
    align-items: center;
    background: #fff;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    height: 40px;
    padding-left: 21px;
    img {
      width: 10px;
      margin-right: 12px;
    }
  }
  .daifuDetails-header_center {
    width: 343px;
    margin: 0 auto;
    padding: 12px 14px;
    background: #ffffff;
    border-radius: 4px;
    box-sizing: border-box;
    .daifuDetails_dingdan {
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      margin-bottom: 12px;
      font-weight: 500;
    }
    .daifuDetails_flexbox {
      display: flex;

      .dingdan-img {
        width: 53px;
        height: 75px;
        border-radius: 4px;
      }
      .daifuDetails_dingdan-title {
        line-height: 21px;
        font-size: 14px;
        color: #333333;
        margin-bottom: 24px;
      }
      .daifuDetails_flexbox_money {
        font-size: 16px;
        color: #999999;
      }
    }
    .daifuDetails_dingdan_border {
      width: 307px;
      height: 0.5px; /*no*/
      background: #f5f5f5;
      margin-top: 17.5px;
    }
    .daifuDetails_dingdan-text {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      margin-top: 12px;
    }
    .description {
      font-size: 13px;
      color: #666666;
      margin-top: 8px;
    }
  }
  .daifuDetails_footer {
    padding: 0 16px;
    margin-top: 12px;
    font-size: 13px;
    color: #999999;
    padding-bottom: 10px;
    background: #f6f6f6;
    .shuoming {
      font-weight: 500;
      font-size: 14px;
    }
    .daifuDetails_footer_text1 {
      margin-top: 6px;
      font-size: 12px;
      color: #999999;
    }
    .daifuDetails_footer_text2 {
      margin-top: 4px;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
